var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content full" }, [
    _c("div", { staticClass: "content_box mt10" }, [
      _c("div", { staticClass: "map_wrap", style: `height: 630px;` }, [
        _c("div", { style: _vm.mapStyle, attrs: { id: "map" } }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }